import { TextInput } from "orcs-design-system";
import styled from "styled-components";

export const TextInputHiddenLabel = styled(TextInput)`
  > label {
    display: none;
  }
`;
